import { store } from '../store/store';

export const guardBeforeEach = (to, from, next) => {
  if (to.matched.some((record) => record.meta.private)) {
    if (!store.state.auth.loggedIn) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
      return;
    }
  }
  next();
};
